import React, { Component, Suspense } from 'react'
import './App.css';
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import "./css/Global.css"
import ForgotPassword from './Pages/ForgotPassword';
// import ResetPassword from './Pages/ResetPassword';

import { RecoilRoot } from 'recoil';
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./Pages/Login'))
const Dash_board = React.lazy(() => import('./Pages/Dashboard'))
const DoctorRegister = React.lazy(() => import('./Pages/DoctorRegister'))
const DoctorClinicSelections = React.lazy(() => import('./Pages/DoctorClinicSelection'))
const OPDMoneyReceipt = React.lazy(() => import('./Pages/Payment/MoneyReceipt'))
const LABMoneyReceipt = React.lazy(() => import('./Pages/LAB/Payment/LABMoneyReceipt'))
const IPDMoneyReceipt = React.lazy(() => import('./Pages/IPD/Payment/IPDMoneyReceipt'))
const CheckinForm = React.lazy(() => import('./Pages/CheckinForm'))
const PrintEyePrescription = React.lazy(() => import('./Pages/Consultation/PrintEyePrescription'))
const PrintPrescription = React.lazy(() => import('./Pages/Consultation/PrintPrescription'))
const PrintPrescriptionV2 = React.lazy(() => import('./Pages/Consultation/PrintPrescriptionV2'))
const PrintPulmonologyPrescription = React.lazy(() => import('./Pages/Consultation/PrintPulmonologyPrescription'))
const PrintDeematologyPrescription = React.lazy(() => import('./Pages/Consultation/PrintDeematologyPrescription'))
const PrintOrthoPrescription = React.lazy(() => import('./Pages/Consultation/PrintOrthoPrescription'))
const PrintDentalPrescription = React.lazy(() => import('./Pages/Consultation/PrintDentalPrescription'))
const PrintFullCustomDentalPrescription = React.lazy(() => import('./Pages/Consultation/PrintFullCustomDentalPrescription'))
const PrintCustomHeaderDentalPrescription = React.lazy(() => import('./Pages/Consultation/PrintCustomHeaderDentalPrescription'))
const FeedBack = React.lazy(() => import('./Pages/PatientFeedback'))
const FileReader = React.lazy(() => import('./Pages/FileReader'))
// Pages
//const ForgotPassword = React.lazy(() => import('./Pages/ForgotPassword'))

const baseUrl =

  //global.baseUrl = 'https://emr-api.healthconnectpro.in';

  //global.baseUrl = "https://testemr-api-php.cb-dev.in"
  global.ROLE_DOCTOR = "rd";
global.ROLE_CLINIC_ADMIN = "rc";
global.ROLE_DEMOCLINIC_ADMIN = "dc";
global.ROLE_OPD_STAFF = "ros";
global.ROLE_IPD_STAFF = "ris";
global.ROLE_LAB_STAFF = "rls";
global.ROLE_PULMO_ADMIN = "plmadm";
global.ROLE_OPTHAL_ADMIN = "optadm";
global.ROLE_OPTHAL_DOCTOR = "optdr";
global.ROLE_PULMO_DOCTOR = "plmdr";
global.genderList = [
  {
    label: "Male",
    value: "Male"
  },
  {
    label: "Female",
    value: "Female"
  },
  {
    label: "Other",
    value: "other"
  }
]
global.DATE_FORMAT = 'DD-MMM-YYYY';
global.DATE_TIME_FORMAT = 'DD-MMM-YYYY hh:mm A';
global.DATE_DAY_FORMAT = 'DD-MMM-YYYY ddd';

global.BUTTON_STYLE = {
  default: {
    fontSize: 15,
    backgroundColor: '#00d285',
    borderColor: '#00d285',
    color: 'white',
    fontWeight: '600',
    fontFamily: '"Montserrat", sans-serif',
  },
  cancel: {
    fontSize: 15,
    backgroundColor: '#f03636',
    borderColor: '#f03636',
    color: 'white',
    fontWeight: '600',
    fontFamily: '"Montserrat", sans-serif',
  },
};


global.formatName = (name) => {
  if (!name) return '';
  return name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};
global.formatUpperCaseName = (name) => {
  if (!name) return '';
  return name.toUpperCase();
};
global.formatAge = (age) => {
  // Convert to string to safely extract integer and fractional parts
  const ageStr = String(age);
  const parts = ageStr.split('.');
  const years = parseInt(parts[0], 10) || 0;
  // Directly take the fractional part as the month number (0–11)
  const months = parts.length > 1 ? parseInt(parts[1], 10) || 0 : 0;

  if (years === 0 && months > 0) {
    return `${months} month${months > 1 ? 's' : ''}`;
  }

  let result = '';
  if (years > 0) {
    result += `${years} yr${years > 1 ? 's' : ''}`;
  }
  if (months > 0) {
    result += (result ? ' ' : '') + `${months} month${months > 1 ? 's' : ''}`;
  }

  return result || '0 years';
};
class App extends Component {
  render() {
    return (
      <RecoilRoot>
        <HashRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/" element={<Dash_board />} />
              <Route exact path="/Login" element={<Login />} />
              <Route exact path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/DoctorRegister" element={<DoctorRegister />} />
              <Route path="/SelectClinic" element={<DoctorClinicSelections />} />
              <Route path="/MoneyReceipt" element={<OPDMoneyReceipt />} />
              <Route path="/LabMoneyReceipt" element={<LABMoneyReceipt />} />
              <Route path="/IPDMoneyReceipt" element={<IPDMoneyReceipt />} />
              <Route path="/CheckinForm" element={<CheckinForm />} />
              <Route path="/PrintEyePrescription" element={<PrintEyePrescription />} />
              <Route path="/PrintPrescription" element={<PrintPrescription />} />
              <Route path="/PrintPrescriptionV2" element={<PrintPrescriptionV2 />} />
              <Route path="/PrintPulmonologyPrescription" element={<PrintPulmonologyPrescription />} />
              <Route path="/PrintDeematologyPrescription" element={<PrintDeematologyPrescription />} />
              <Route path="/PrintOrthoPrescription" element={<PrintOrthoPrescription />} />
              <Route path="/PrintDentalPrescription" element={<PrintDentalPrescription />} />
              <Route path="/PrintCustomHeaderDentalPrescription" element={<PrintCustomHeaderDentalPrescription />} />
              <Route path="/PrintFullCustomDentalPrescription" element={<PrintFullCustomDentalPrescription />} />
              <Route path="/UGF0aWVudEZlZWRiYWNr/:search" element={<FeedBack />} />
              <Route path="/FileReader" name="FileReader" element={<FileReader />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </HashRouter>
      </RecoilRoot>
    )
  }
}

export default App



